import Api from "../../../services/Api";
import { sanitizeSerialPathParam } from "../../../lib/utils/apiValidation";

export function fetchSessionHistory(serialNumber, params) {
  const serial = sanitizeSerialPathParam(serialNumber);
  return Api.get(`/service/iqevse-csms/api/v1/ev_chargers/${serial}/session_history`, {
    ...params,
  });
}
